import { useEffect, useState } from "react";

import "./GameLabV3Mobile.scss";

const GameLabV3Mobile = () => {
  const [iframeSrc, setIframeSrc] = useState<string>("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const iframe = params.get("iframe");
    if (iframe) {
      setIframeSrc(decodeURIComponent(iframe));
    }
  }, []);

  return <iframe className="game-iframe" src={iframeSrc} />;
};

export default GameLabV3Mobile;
